import { render, staticRenderFns } from "./TestingList.vue?vue&type=template&id=3ea82255"
import script from "./TestingList.vue?vue&type=script&lang=js"
export * from "./TestingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports